import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles'
export const useStyles = makeStyles((theme) => ({

  topImage: {
    height: '300px',
    '@media (max-width: 812px)': {
      marginTop: theme.spacing(6),
    }
  },

  titlePrincipal: {
    fontWeight: 600,
    width: '100%',
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    '@media (max-width: 812px)': {
      marginTop: theme.spacing(3),
      paddingLeft: theme.spacing(1),
    }
  },

  instructions: {
    color: theme.palette.primary.color,
    marginTop: theme.spacing(3),
    // fontWeight: 'bold !important',
  },
  subTitle: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 19,
    marginBottom: '8% !important'
  },

  close: {
    alignSelf: 'flex-end',
    marginRight: theme.spacing(3),
    marginTop: theme.spacing(3),
    '&&:focus': {
      outline: 'none'
    }
  },

  details: {
    marginTop: theme.spacing(3),
  },

  info: {
    marginLeft: theme.spacing(1),
  },

  modal: {
    '@media (max-width: 650px)': {
      marginLeft: theme.spacing(3),
    }
  },

  table: {
    marginTop: theme.spacing(2),
  },

  bioResults: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '85vh',
    width: '50% !important',
    ['@media only screen and (max-width: 800px)']: {
      height: '75vh',
      width: '90% !important'
    },
  },

  bioLoading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  button: {
    marginBottom: theme.spacing(2),
  },

  bioLoadingText: {
    '@media (max-width: 650px)': {
      marginLeft: theme.spacing(3),
    }
  },

  stageSubTitle: {
    width: '100%',
    paddingLeft: theme.spacing(1),
  },
  helpIconGreen1: {
    color: '#28A745',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 5,
  },
  helpIconRed1: {
    color: 'red',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 5,
  },
}))